// FAQ Image Registry - import all images for build-time validation

// Getting Started images
import arrow from "./getting-started/arrow.svg";
import greenIcon from "./getting-started/green-icon.png";
import redIcon from "./getting-started/red-icon.png";
import sysTrayPopup from "./getting-started/sys-tray-popup.png";
import loggedOutMenu from "./getting-started/logged-out-menu.png";
import loggedInMenu from "./getting-started/logged-in-menu.png";
import pinIcon from "./getting-started/pin-icon.png";
import bookmarkSettings from "./getting-started/bookmark-settings.png";
import threeDotsEdge from "./getting-started/three-dots-edge.png";
import moreToolsEdge from "./getting-started/more-tools-edge.png";

// Daily Use images
import selectMultipleEntries from "./daily-use/select-multiple-entries.png";
import selectGroup from "./daily-use/select-group.png";
import entriesGrouped from "./daily-use/entries-grouped.png";
import addEntryButton from "./daily-use/add-entry-button.png";
import addEntryEmptyPopup from "./daily-use/add-entry-empty-popup.png";
import addEntryFilledPopup from "./daily-use/add-entry-filled-popup.png";
import addEntryAdded from "./daily-use/add-entry-added.png";
import duplicateEntrySelected from "./daily-use/duplicate-entry-selected.png";
import duplicateEntryButton from "./daily-use/duplicate-entry-button.png";
import duplicateEntryDuplicated from "./daily-use/duplicate-entry-duplicated.png";

// Export as a registry for type-safe lookups
export const faqImages = {
  // Getting Started
  arrow,
  greenIcon,
  redIcon,
  sysTrayPopup,
  loggedOutMenu,
  loggedInMenu,
  pinIcon,
  bookmarkSettings,
  threeDotsEdge,
  moreToolsEdge,
  // Daily Use
  selectMultipleEntries,
  selectGroup,
  entriesGrouped,
  addEntryButton,
  addEntryEmptyPopup,
  addEntryFilledPopup,
  addEntryAdded,
  duplicateEntrySelected,
  duplicateEntryButton,
  duplicateEntryDuplicated,
} as const;

export type FAQImageKey = keyof typeof faqImages;
